<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <image-list
    entity-name="restaurantImage"
    :model="model"
    icon="mdi-calendar-today"
  />
</template>

<script>

import RestaurantImage from '@/model/dataLayer/api/restaurant/RestaurantImage'
import ImageList from '@/views/widget/commonLogic/ImageList.vue'

export default {
  components: {
    ImageList
  },
  data: function () {
    return ({
      model: RestaurantImage
    })
  }
}
</script>
